import { apiGet, apiPost, apiDelete, apiPut } from "@redriver/cinnamon";

const NAMESPACE = "ADMIN/LIST_DOCUMENT_TYPES";

const ActionTypes = {
  GetDocumentTypes: `${NAMESPACE}/GET_DOCUMENT_TYPES`,
  AddDocumentType: `${NAMESPACE}/ADD_DOCUMENT_TYPE`,
  UpdateDocumentType: `${NAMESPACE}/UPDATE_DOCUMENT_TYPE`,
  DeleteDocumentType: `${NAMESPACE}/DELETE_DOCUMENT_TYPE`,
};

export const getDocumentTypes = () => {
  return apiGet(ActionTypes.GetDocumentTypes, `document-types`);
};

export const addDocumentType = (data) => {
  return apiPost(ActionTypes.AddDocumentType, `document-types`, data);
};

export const updateDocumentType = (data, documentTypeId) => {
  return apiPut(
    ActionTypes.UpdateDocumentType,
    `document-types/${documentTypeId}`,
    data,
  );
};

export const deleteDocumentType = (documentTypeId) => {
  return apiDelete(
    ActionTypes.DeleteDocumentType,
    `document-types/${documentTypeId}`,
  );
};
